import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    margin: "4rem 0",
    color: "#fff",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  topSection: {
    padding: "0.75rem 1.5rem",
  },
  bottomSection: {},
  socials: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
  },
  socialIcon: {
    padding: theme.spacing(3),

    [theme.breakpoints.down("md")]: {
      padding: 0,
    },

    "& img": {
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      maxWidth: theme.spacing(3.5),
    },
  },
  photoWrapper: {
    position: "relative",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    [theme.breakpoints.down("md")]: {
      marginTop: 0,
      marginBottom: -1,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  photoMask: {
    position: "absolute",
    inset: 0,
    mixBlendMode: "color",
    backgroundColor: "#D9D9D9",
  },
  photoImg: {
    height: "100%",

    "& img": {
      maxWidth: "none",
      height: "100%",

      [theme.breakpoints.down("md")]: {
        width: "100%",
        height: "auto",
      },
    },
  },
  main: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "2rem 4rem",

    [theme.breakpoints.down("md")]: {
      backgroundColor: theme.palette.primary.main,
      margin: "0 -10rem",
      padding: "1.5rem 11.5rem",
    },
  },
  name: {
    fontSize: 40,
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      display: "flex",
      fontSize: 30,
      textAlign: "center",
    },
  },
  title: {
    fontSize: 30,
    fontWeight: 500,

    [theme.breakpoints.down("md")]: {
      fontSize: 20,
      fontWeight: 700,
      textAlign: "center",
      paddingTop: theme.spacing(1.5),
    },
  },
  shortTitle: {
    fontSize: 30,
    fontWeight: 600,
    width: "100%",
    padding: "0.5rem",
    textAlign: "center",
    backgroundColor: theme.palette.primary.main,
  },
  description: {
    paddingTop: theme.spacing(2.5),
    fontSize: 20,

    [theme.breakpoints.down("md")]: {
      fontSize: 16,
      textAlign: "center",
      paddingTop: theme.spacing(1.5),
    },
  },
}));
